<template>
  <div>
    <v-container>
      <v-row>
        <h2 class="pb-5">
          {{ this.pageTitle }}
        </h2>
      </v-row>

      <v-form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-subheader class="blue--text mt-n3 mb-n3 ml-n2"
                >{{$t('recimport.personinfo')}}</v-subheader
              >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mb-8" />
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8">
                  <v-autocomplete
                    outlined
                    :label="this.$t('columns.actions')"
                    type="text"
                    ref="action"
                    :items="actionlist"
                    hide-selected
                    v-model="formData.personAction"
                    @input="updateValue"
                    dense
                    clearable
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <div class="text-center">
                    <v-file-input
                      :label="this.$t('payeeinputprocess.choosefiles')"
                      ref="importfile"
                      v-model="formData.personFile"
                      outlined
                      dense
                      show-size
                      prepend-icon=""
                      accept=".zip"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                    >
                    </v-file-input>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <v-btn
                    color="#fd9941"
                    style="width: 100px; color: white"
                    v-on:click="PersonSubmit()"
                    >{{$t('button.submit')}}</v-btn
                  >
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>

      <v-form class="mt-5">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-subheader class="blue--text mt-n3 mb-n3 ml-n2"
                >{{$t('recimport.staffdetails')}}</v-subheader
              >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mb-8" />
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8">
                  <v-autocomplete
                    outlined
                    :label="this.$t('columns.actions')"
                    type="text"
                    ref="action"
                    :items="actionlistStaff"
                    hide-selected
                    v-model="formData.staffAction"
                    @input="updateValue"
                    dense
                    clearable
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <div class="text-center">
                    <v-file-input
                      :label="this.$t('payeeinputprocess.choosefiles')"
                      ref="importfile"
                      v-model="formData.staffFile"
                      outlined
                      dense
                      show-size
                      prepend-icon=""
                      accept=".csv"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                    >
                    </v-file-input>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <v-btn
                    color="#fd9941"
                    style="width: 100px; color: white"
                    v-on:click="StaffSubmit()"
                    >{{$t('button.submit')}}</v-btn
                  >
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>

      <v-form class="mt-5">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-subheader class="blue--text mt-n3 mb-n3 ml-n2"
                >{{$t('recimport.staffmov')}}</v-subheader
              >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mb-8" />
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8">
                  <v-autocomplete
                    outlined
                    :label="this.$t('columns.actions')"
                    type="text"
                    ref="action"
                    :items="actionlistStaff"
                    hide-selected
                    v-model="formData.staffmovAction"
                    @input="updateValue"
                    dense
                    clearable
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <div class="text-center">
                    <v-file-input
                      :label="this.$t('payeeinputprocess.choosefiles')"
                      ref="importfile"
                      v-model="formData.staffmovFile"
                      outlined
                      dense
                      show-size
                      prepend-icon=""
                      accept=".csv"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                    >
                    </v-file-input>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <v-btn
                    color="#fd9941"
                    style="width: 100px; color: white"
                    v-on:click="StaffMovSubmit()"
                    >{{$t('button.submit')}}</v-btn
                  >
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>

      <v-form class="mt-5">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-subheader class="blue--text mt-n3 mb-n3 ml-n2"
                >{{$t('recimport.staffbankacc')}}</v-subheader
              >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mb-8" />
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8">
                  <v-autocomplete
                    outlined
                    :label="this.$t('columns.actions')"
                    type="text"
                    ref="action"
                    :items="actionlist"
                    hide-selected
                    v-model="formData.staffBankAction"
                    @input="updateValue"
                    dense
                    clearable
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <div class="text-center">
                    <v-file-input
                      :label="this.$t('payeeinputprocess.choosefiles')"
                      ref="importfile"
                      v-model="formData.staffBankFile"
                      outlined
                      dense
                      show-size
                      prepend-icon=""
                      accept=".csv"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                    >
                    </v-file-input>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <v-btn
                    color="#fd9941"
                    style="width: 100px; color: white"
                    v-on:click="StaffBankSubmit()"
                    >{{$t('button.submit')}}</v-btn
                  >
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>

      <v-form class="mt-5">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-subheader class="blue--text mt-n3 mb-n3 ml-n2"
                >{{$t('recimport.personpayrollinstruction')}}</v-subheader
              >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mb-8" />
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8">
                  <v-autocomplete
                    outlined
                    :label="this.$t('columns.actions')"
                    type="text"
                    ref="action"
                    :items="actionlist"
                    hide-selected
                    v-model="formData.psnPayrollAction"
                    @input="updateValue"
                    dense
                    clearable
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <div class="text-center">
                    <v-file-input
                      :label="this.$t('payeeinputprocess.choosefiles')"
                      ref="importfile"
                      v-model="formData.psnPayrollFile"
                      outlined
                      dense
                      show-size
                      prepend-icon=""
                      accept=".csv"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                    >
                    </v-file-input>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <v-btn
                    color="#fd9941"
                    style="width: 100px; color: white"
                    v-on:click="PsnPayrollSubmit()"
                    >{{$t('button.submit')}}</v-btn
                  >
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>

      <v-form class="mt-5">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-subheader class="blue--text mt-n3 mb-n3 ml-n2"
                >{{$t('recimport.personstatutoryinfo')}}</v-subheader
              >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mb-8" />
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8">
                  <v-autocomplete
                    outlined
                    :label="this.$t('columns.actions')"
                    type="text"
                    ref="action"
                    :items="actionlist"
                    hide-selected
                    v-model="formData.personStatutoryAction"
                    @input="updateValue"
                    dense
                    clearable
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <div class="text-center">
                    <v-file-input
                      :label="this.$t('payeeinputprocess.choosefiles')"
                      ref="importfile"
                      v-model="formData.personStatutoryFile"
                      outlined
                      dense
                      show-size
                      prepend-icon=""
                      accept=".csv"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                    >
                    </v-file-input>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <v-btn
                    color="#fd9941"
                    style="width: 100px; color: white"
                    v-on:click="personStatutorySubmit()"
                    >{{$t('button.submit')}}</v-btn
                  >
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>

      <v-form class="mt-5">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-subheader class="blue--text mt-n3 mb-n3 ml-n2"
                >{{$t('personnelmobile.family')}}</v-subheader
              >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mb-8" />
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8">
                  <v-autocomplete
                    outlined
                    :label="this.$t('columns.actions')"
                    type="text"
                    ref="action"
                    :items="actionlist"
                    hide-selected
                    v-model="formData.familyAction"
                    @input="updateValue"
                    dense
                    clearable
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <div class="text-center">
                    <v-file-input
                      :label="this.$t('payeeinputprocess.choosefiles')"
                      ref="importfile"
                      v-model="formData.familyFile"
                      outlined
                      dense
                      show-size
                      prepend-icon=""
                      accept=".csv"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                    >
                    </v-file-input>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <v-btn
                    color="#fd9941"
                    style="width: 100px; color: white"
                    v-on:click="FamilySubmit()"
                  >
                    {{$t('button.submit')}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>

      <v-form class="mt-5">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-subheader class="blue--text mt-n3 mb-n3 ml-n2">
                {{$t('personnelmobile.contact')}}
              </v-subheader>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mb-8" />
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8">
                  <v-autocomplete
                    outlined
                    :label="this.$t('columns.actions')"
                    type="text"
                    ref="action"
                    :items="actionlist"
                    hide-selected
                    v-model="formData.contactAction"
                    @input="updateValue"
                    dense
                    clearable
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <div class="text-center">
                    <v-file-input
                      :label="this.$t('payeeinputprocess.choosefiles')"
                      ref="importfile"
                      v-model="formData.contactFile"
                      outlined
                      dense
                      show-size
                      prepend-icon=""
                      accept=".csv"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                    >
                    </v-file-input>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <v-btn
                    color="#fd9941"
                    style="width: 100px; color: white"
                    v-on:click="ContactSubmit()"
                  >
                    {{$t('button.submit')}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>

      <v-form class="mt-5">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-subheader class="blue--text mt-n3 mb-n3 ml-n2">
                {{$t('setuppersonpayrolldirectassignment.personpayrolldirectassignment')}}
              </v-subheader>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mb-8" />
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8">
                  <v-autocomplete
                    outlined
                    :label="this.$t('columns.actions')"
                    type="text"
                    ref="action"
                    :items="actionlistStaff"
                    hide-selected
                    v-model="formData.personpayrolldirectassignmentAction"
                    @input="updateValue"
                    dense
                    clearable
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <div class="text-center">
                    <v-file-input
                      :label="this.$t('payeeinputprocess.choosefiles')"
                      ref="importfile"
                      v-model="formData.personpayrolldirectassignmentFile"
                      outlined
                      dense
                      show-size
                      prepend-icon=""
                      accept=".csv"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                    >
                    </v-file-input>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <v-btn
                    color="#fd9941"
                    style="width: 100px; color: white"
                    v-on:click="PsndirectassignmentSubmit()"
                  >
                    {{$t('button.submit')}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>

      <v-form class="mt-5">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-subheader class="blue--text mt-n3 mb-n3 ml-n2">
                {{$t('recimport.mmstatinstructsetup')}}
              </v-subheader>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mb-8" />
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8">
                  <v-autocomplete
                    outlined
                    :label="this.$t('columns.actions')"
                    type="text"
                    ref="action"
                    :items="actionlist"
                    hide-selected
                    v-model="formData.mmstatutoryinstructionsetupAction"
                    @input="updateValue"
                    dense
                    clearable
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <div class="text-center">
                    <v-file-input
                      :label="this.$t('payeeinputprocess.choosefiles')"
                      ref="importfile"
                      v-model="formData.mmstatutoryinstructionsetupFile"
                      outlined
                      dense
                      show-size
                      prepend-icon=""
                      accept=".csv"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                    >
                    </v-file-input>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <v-btn
                    color="#fd9941"
                    style="width: 100px; color: white"
                    v-on:click="MMpsnstatutorySubmit()"
                  >
                    {{$t('button.submit')}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>

      <v-form class="mt-5">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-subheader class="blue--text mt-n3 mb-n3 ml-n2">
                {{$t('leavebalanceadjustment')}}
              </v-subheader>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mb-8" />
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8">
                  <v-autocomplete
                    outlined
                    :label="this.$t('columns.actions')"
                    type="text"
                    ref="action"
                    :items="actionlistStaff"
                    hide-selected
                    v-model="formData.lvadjAction"
                    @input="updateValue"
                    dense
                    clearable
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <div class="text-center">
                    <v-file-input
                      :label="this.$t('payeeinputprocess.choosefiles')"
                      ref="importfile"
                      v-model="formData.lvadjFile"
                      outlined
                      dense
                      show-size
                      prepend-icon=""
                      accept=".csv"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                    >
                    </v-file-input>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <v-btn
                    color="#fd9941"
                    style="width: 100px; color: white"
                    v-on:click="LeaveBalAdjustSubmit()"
                  >
                    {{$t('button.submit')}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>

      <v-form class="mt-5">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-subheader class="blue--text mt-n3 mb-n3 ml-n2">
                {{$t('workschedulegroupassignment')}}
              </v-subheader>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mb-8" />
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8">
                  <v-autocomplete
                    outlined
                    :label="this.$t('columns.actions')"
                    type="text"
                    ref="action"
                    :items="actionlist"
                    hide-selected
                    v-model="formData.wsgrpassignAction"
                    @input="updateValue"
                    dense
                    clearable
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <div class="text-center">
                    <v-file-input
                      :label="this.$t('payeeinputprocess.choosefiles')"
                      ref="importfile"
                      v-model="formData.wsgrpassignFile"
                      outlined
                      dense
                      show-size
                      prepend-icon=""
                      accept=".csv"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                    >
                    </v-file-input>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <v-btn
                    color="#fd9941"
                    style="width: 100px; color: white"
                    v-on:click="WorkScheduleGroupAssignSubmit()"
                  >
                    {{$t('button.submit')}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>

      <v-form class="mt-5">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-subheader class="blue--text mt-n3 mb-n3 ml-n2">
                {{$t('workschedulebystaffforaperiod')}}
              </v-subheader>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mb-8" />
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8">
                  <v-autocomplete
                    outlined
                    :label="this.$t('columns.actions')"
                    type="text"
                    ref="action"
                    :items="actionlist"
                    hide-selected
                    v-model="formData.wsstaffassignAction"
                    @input="updateValue"
                    dense
                    clearable
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <div class="text-center">
                    <v-file-input
                      :label="this.$t('payeeinputprocess.choosefiles')"
                      ref="importfile"
                      v-model="formData.wsstaffassignFile"
                      outlined
                      dense
                      show-size
                      prepend-icon=""
                      accept=".csv"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                    >
                    </v-file-input>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-n4 mt-n8" align-self="center">
                  <v-btn
                    color="#fd9941"
                    style="width: 100px; color: white"
                    v-on:click="WorkScheduleStaffAssignSubmit()"
                  >
                    {{$t('button.submit')}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>

    </v-container>
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>


<script>
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  props: {
    parentObject: Object,
  },
  components: {
    "app-error": ErrorDialog,
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
      },
      pageTitle: this.$t('import'),
      actionlist: [
        { 
          text: this.$t('reportsparam.createnew'),
          value: "Create" 
        },
        {
          text: this.$t('reportsparam.updexist'),
          value: "Update",
        },
      ],
      actionlistStaff: [{ text: this.$t('reportsparam.createnew'), value: "Create" }],
      errMsg: "",
      isErr: false,
      formData: {
        personAction: "",
        personFile: null,
        staffAction: "",
        staffFile: null,
        staffmovAction: "",
        staffmovFile: null,
        staffBankAction: "",
        staffBankFile: null,
        psnPayrollAction: "",
        psnPayrollFile: null,
        personStatutoryAction: "",
        personStatutoryFile: null,
        familyAction: "",
        familyFile: null,
        contactAction: "",
        contactFile: null,
        personpayrolldirectassignmentAction: "",
        personpayrolldirectassignmentFile: null,
        mmstatutoryinstructionsetupAction: "",
        mmstatutoryinstructionsetupFile: null,
        lvadjAction: "",
        lvadjFile: null,
        wsgrpassignAction: "",
        wsgrpassignFile: null,
        wsstaffassignAction: "",
        wsstaffassignFile: null,
      },
    };
  },
  methods: {
    updateValue() {
      this.$emit("input", {
        action: this.formData.action,
      });
    },
    PersonSubmit() {
      console.log(this.formData);

      let data = new FormData();
      data.append("action", this.formData.personAction);
      data.append("file", this.formData.personFile);
      data.append("userid", this.$store.getters.userId);

      this.$store.dispatch('post', {url: "/import/person", payload: data,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log(res);
          if (res.data.status == 201) {
            this.$dialog.alert("Data Imported Successfully").then((dialog) => {
              console.log(dialog);
            });
          } else {
            this.isErr = true;
            this.errMsg = res.data.error;
          }
        })
        .catch((err) => {
          console.log(err);
          this.isErr = true;
          this.errMsg = err;
        });
    },
    StaffSubmit() {
      console.log(this.formData);

      let data = new FormData();
      data.append("action", this.formData.staffAction);
      data.append("file", this.formData.staffFile);
      data.append("userid", this.$store.getters.userId);

      this.$store.dispatch('post', {url: "/import/staff", payload: data, 
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log(res);
          if (res.data.status == 201) {
            this.$dialog.alert("Data Imported Successfully").then((dialog) => {
              console.log(dialog);
            });
          } else {
            this.isErr = true;
            this.errMsg = res.data.error;
          }
        })
        .catch((err) => {
          console.log(err);
          this.isErr = true;
          this.errMsg = err;
        });
    },
    StaffMovSubmit() {
      console.log(this.formData);

      let data = new FormData();
      data.append("action", this.formData.staffmovAction);
      data.append("file", this.formData.staffmovFile);
      data.append("userid", this.$store.getters.userId);

      this.$store.dispatch('post', {url: "/import/staffmov", payload: data, 
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log(res);
          if (res.data.status == 201) {
            this.$dialog.alert("Data Imported Successfully").then((dialog) => {
              console.log(dialog);
            });
          } else {
            this.isErr = true;
            this.errMsg = res.data.error;
          }
        })
        .catch((err) => {
          console.log(err);
          this.isErr = true;
          this.errMsg = err;
        });
    },
    StaffBankSubmit() {
      console.log(this.formData);

      let data = new FormData();
      data.append("action", this.formData.staffBankAction);
      data.append("file", this.formData.staffBankFile);
      data.append("userid", this.$store.getters.userId);

      this.$store.dispatch('post', {url: "/import/staffbank", payload: data, 
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log(res);
          if (res.data.status == 201) {
            this.$dialog.alert("Data Imported Successfully").then((dialog) => {
              console.log(dialog);
            });
          } else {
            this.isErr = true;
            this.errMsg = res.data.error;
          }
        })
        .catch((err) => {
          console.log(err);
          this.isErr = true;
          this.errMsg = err;
        });
    },
    PsnPayrollSubmit() {
      console.log(this.formData);

      let data = new FormData();
      data.append("action", this.formData.psnPayrollAction);
      data.append("file", this.formData.psnPayrollFile);
      data.append("userid", this.$store.getters.userId);

      this.$store.dispatch('post', {url: "/import/psnpayroll", payload: data,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log(res);
          if (res.data.status == 201) {
            this.$dialog.alert("Data Imported Successfully.").then((dialog) => {
              console.log(dialog);
            });
          } else {
            this.isErr = true;
            this.errMsg = res.data.error;
          }
        })
        .catch((err) => {
          console.log(err);
          this.isErr = true;
          this.errMsg = err;
        });
    },
    personStatutorySubmit() {
      console.log(this.formData);

      let data = new FormData();
      data.append("action", this.formData.personStatutoryAction);
      data.append("file", this.formData.personStatutoryFile);
      data.append("userid", this.$store.getters.userId);

      this.$store.dispatch('post', {url: "/import/personstatutory", payload: data,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log(res);
          if (res.data.status == 201) {
            this.$dialog.alert("Data Imported Successfully.").then((dialog) => {
              console.log(dialog);
            });
          } else {
            this.isErr = true;
            this.errMsg = res.data.error;
          }
        })
        .catch((err) => {
          console.log(err);
          this.isErr = true;
          this.errMsg = err;
        });
    },

    FamilySubmit() {
      let data = new FormData();
      data.append("action", this.formData.familyAction);
      data.append("file", this.formData.familyFile);
      data.append("userid", this.$store.getters.userId);

      this.$store.dispatch('post', {url: "/import/family", payload: data,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == 201) {
          this.$dialog.alert("Data Imported Successfully").then((dialog) => {
            console.log(dialog);
          });
        } else {
          this.isErr = true;
          this.errMsg = res.data.error;
        }
      })
      .catch((err) => {
        console.log(err);
        this.isErr = true;
        this.errMsg = err;
      });
    },

    ContactSubmit() {
      let data = new FormData();
      data.append("action", this.formData.contactAction);
      data.append("file", this.formData.contactFile);
      data.append("userid", this.$store.getters.userId);

      this.$store.dispatch('post', {url: "/import/contact", payload: data,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == 201) {
          this.$dialog.alert("Data Imported Successfully").then((dialog) => {
            console.log(dialog);
          });
        } else {
          this.isErr = true;
          this.errMsg = res.data.error;
        }
      })
      .catch((err) => {
        console.log(err);
        this.isErr = true;
        this.errMsg = err;
      });
    },

    PsndirectassignmentSubmit() {
      let data = new FormData();
      data.append("action", this.formData.personpayrolldirectassignmentAction);
      data.append("file", this.formData.personpayrolldirectassignmentFile);
      data.append("userid", this.$store.getters.userId);

      this.$store.dispatch('post', {url: "/import/psndirectassigment", payload: data,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == 201) {
          this.$dialog.alert("Data Imported Successfully").then((dialog) => {
            console.log(dialog);
          });
        } else {
          this.isErr = true;
          this.errMsg = res.data.error;
        }
      })
      .catch((err) => {
        console.log(err);
        this.isErr = true;
        this.errMsg = err;
      });
    },

    MMpsnstatutorySubmit() {
      let data = new FormData();
      data.append("action", this.formData.mmstatutoryinstructionsetupAction);
      data.append("file", this.formData.mmstatutoryinstructionsetupFile);
      data.append("userid", this.$store.getters.userId);

      this.$store.dispatch('post', {url: "/import/mmpsnstatutory", payload: data,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == 201) {
          this.$dialog.alert("Data Imported Successfully").then((dialog) => {
            console.log(dialog);
          });
        } else {
          this.isErr = true;
          this.errMsg = res.data.error;
        }
      })
      .catch((err) => {
        console.log(err);
        this.isErr = true;
        this.errMsg = err;
      });
    },

    LeaveBalAdjustSubmit() {
      let data = new FormData();
      data.append("action", this.formData.lvadjAction);
      data.append("file", this.formData.lvadjFile);
      data.append("userid", this.$store.getters.userId);

      this.$store.dispatch('post', {url: "/import/lvadj", payload: data,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == 201) {
          this.$dialog.alert("Data Imported Successfully").then((dialog) => {
            console.log(dialog);
          });
        } else {
          this.isErr = true;
          this.errMsg = res.data.error;
        }
      })
      .catch((err) => {
        console.log(err);
        this.isErr = true;
        this.errMsg = err;
      });
    },

    WorkScheduleGroupAssignSubmit() {
      let data = new FormData();
      data.append("action", this.formData.wsgrpassignAction);
      data.append("file", this.formData.wsgrpassignFile);
      data.append("userid", this.$store.getters.userId);

      this.$store.dispatch('post', {url: "/import/wsgrpassign", payload: data,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == 201) {
          this.$dialog.alert("Data Imported Successfully").then((dialog) => {
            console.log(dialog);
          });
        } else {
          this.isErr = true;
          this.errMsg = res.data.error;
        }
      })
      .catch((err) => {
        console.log(err);
        this.isErr = true;
        this.errMsg = err;
      });
    },

    WorkScheduleStaffAssignSubmit() {
      let data = new FormData();
      data.append("action", this.formData.wsstaffassignAction);
      data.append("file", this.formData.wsstaffassignFile);
      data.append("userid", this.$store.getters.userId);

      this.$store.dispatch('post', {url: "/import/wsstaffassign", payload: data,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == 201) {
          this.$dialog.alert("Data Imported Successfully").then((dialog) => {
            console.log(dialog);
          });
        } else {
          this.isErr = true;
          this.errMsg = res.data.error;
        }
      })
      .catch((err) => {
        console.log(err);
        this.isErr = true;
        this.errMsg = err;
      });
    },

  },
  mounted() {},
};
</script>